//Componentes generales
import React, { useReducer, useContext, useEffect } from "react";
import solicitudesReducer from "./solicitudesReducer";
import solicitudesContext from "./solicitudesContext";
import moment from "moment";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import {
  getSolicitudesByFiltrosRango,
  getSolicitudesByFiltrosRangoAndNroCta,
} from "../../api/solicitudAjuste";
import { getProviders, uploadProvider } from "../../api/abmProvider";

//Socket
import { SocketContext } from "../socket/socket";

//Acciones
import {
  ACTUALIZAR_SOLICITUD,
  AGREGAR_SOLICITUD,
  MODIFICAR_FILTROS_ESTADOS_SOLICITUD,
  MODIFICAR_FILTROS_RANGO_SOLICITUD,
  INICIAR_FILTROS_SOLICITUD,
} from "./solicitudesActions";

//Estados de autorización
import { STATES_SOLICITUD } from "../../utils/states";
import { filtrosSolicitudToString } from "../../utils/funciones";

//Valores iniciales
const initialState = {
  solicitudes: null,
  filtrosRango: {
    fecAlt: {
      //desde: new Date(moment("01/01/1980", "DD/MM/YYYY").toDate()),
      desde: new Date(moment(new Date()).subtract(365, "days")),
      hasta: new Date(moment(new Date())),
    },
  },
  filtrosEstado: {
    //states: [],
    state: STATES_SOLICITUD,
    tDocAbmProvider: [{}],
  },
  filtrosEstadoPredeterminado: null,
  cargando: false,
};

const SolicitudesState = (props) => {
  const server = useContext(SocketContext);

  /* 
        Disparadores que sincronizan la lista de solicitudes ante la creación de una solicitud de ajuste.
    */
  useEffect(() => {
    if (server) {
      //Solicitud Nueva
      server.on("addSolicitudAjuste", (solicitud) => {
        console.log("RECIBO LA SOLICITUD DE AJUSTE CREADA");
        dispatch({
          type: AGREGAR_SOLICITUD,
          payload: solicitud,
        });
      });

      return () => server.off("addSolicitudAjuste");
    }
  }, [server]);

  /* 
        Disparadores que sincronizan la lista de solicitudes ante la modificación de una solicitud.
    */
  useEffect(() => {
    if (server) {
      //Solicitud Modificada
      server.on("modSolicitudAjuste", ({ solicitud }) => {
        dispatch({
          type: ACTUALIZAR_SOLICITUD,
          payload: solicitud,
        });
      });

      return () => server.off("modSolicitudAjuste");
    }
  }, [server]);

  const [state, dispatch] = useReducer(solicitudesReducer, initialState);

  //Logica de solicitudes state;

  //Inicializa los filtros dependiendo del usuarios
  const iniciarFiltros = async (activeWorkSpace, usuario = "") => {
    try {
      console.log("Entra en inciar Filtros de Solicitudes de Ajuste");
      //Paso todos los dates de los filtros rango a un valor valido ademas de transfor en cadena de string para pasar en peticion get.
      const filtrosString = filtrosSolicitudToString(initialState.filtrosRango);

      let respSolicitudes = [];
      let proveedores = [];

      if (usuario.nroCta !== null && usuario.nroCta.trim() !== "") {
        //Relizo peticion con los parametros de rango y el usuario en secion
        respSolicitudes = await getSolicitudesByFiltrosRangoAndNroCta(
          usuario.nroCta,
          filtrosString
        );
        proveedores.push({ nroCta: usuario.nroCta, nombre: usuario.fullName });
      } else {
        respSolicitudes = await getSolicitudesByFiltrosRango(filtrosString);
        //Obtengo los Proveedores
        console.log("ENTRO AL ACTUALIZAR PROVEEDORES");
        const respProveedores = await getProviders();
        proveedores = respProveedores.data.data.map((p) => ({
          nroCta: p.nroCta,
          nombre: p.nombre,
        }));
        proveedores.push({ nroCta: "", nombre: "" });
      }

      console.log(respSolicitudes);
      console.log(filtrosString);

      let state = [];
      if (activeWorkSpace.todos == 1) {
        state = STATES_SOLICITUD;
      } else if (activeWorkSpace.pendientes == 1) {
        state = ["PENDIENTE"];
      } else if (activeWorkSpace.cerradas == 1) {
        state = ["CERRADA"];
      }

      const filtrosEstado = {
        ...initialState.filtrosEstado,
        state: state,
        tDocAbmProvider: proveedores,
      };

      const filtrosRango = { ...initialState.filtrosRango };

      const listaSolicitudes = respSolicitudes.data.data;

      dispatch({
        type: INICIAR_FILTROS_SOLICITUD,
        payload: {
          solicitudes: listaSolicitudes,
          filtrosEstado: filtrosEstado,
          filtrosRango: filtrosRango,
        },
      });
      dispatch({
        type: MODIFICAR_FILTROS_RANGO_SOLICITUD,
        payload: { filtrosRango, solicitudes:listaSolicitudes },
      });
    } catch (error) {
      console.log(error);
      console.log(
        "Error a la hora de iniciar filtros en solicitudes de ajuste"
      );
    }
  };

  //Modifica los filtros de rango y trae las solicitudes acorde a los parametros enviados
  const modificarFiltrosRango = async (nroCta, filtrosRango) => {
    const filtrosString = filtrosSolicitudToString(filtrosRango);

    let respSolicitudes;

    if (nroCta !== null && nroCta.trim() !== "") {
      //Relizo peticion con los parametros de rango y el usuario en sesion
      respSolicitudes = await getSolicitudesByFiltrosRangoAndNroCta(
        nroCta,
        filtrosString
      );
    } else {
      respSolicitudes = await getSolicitudesByFiltrosRango(filtrosString);
    }

    const solicitudes = respSolicitudes.data.data;

    dispatch({
      type: MODIFICAR_FILTROS_RANGO_SOLICITUD,
      payload: { filtrosRango, solicitudes },
    });
  };

  //Modifica los filtros de estado
  const modificarFiltrosEstado = (filtrosEstados) => {
    dispatch({
      type: MODIFICAR_FILTROS_ESTADOS_SOLICITUD,
      payload: filtrosEstados,
    });
  };

  //Filtra una lista de solicitudes de acuerdo a los filtros
  const filtrar = (lista, filtrosEstado) => {
    console.log("Entra a la función filtrar de solicitudesState");
    if (!lista || lista === undefined) return [];

    const listaFiltrada = lista.filter((item) => {
      return (
        filtrosEstado.state.includes(item.state) &&
        filtrosEstado.tDocAbmProvider
          .map((prov) => prov.nroCta)
          .includes(item.nroCta)
      );
    });

    return listaFiltrada;
  };

  return (
    <solicitudesContext.Provider
      value={{
        solicitudes: state.solicitudes,
        cargando: state.cargando,
        filtrosEstado: state.filtrosEstado,
        filtrosRango: state.filtrosRango,
        iniciarFiltros,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        filtrar,
      }}
    >
      {props.children}
    </solicitudesContext.Provider>
  );
};

export default SolicitudesState;